export const reportConfigData = [
  {
    "type": "INPUT_DATE_TIME",
    "description": "Дата",
    "main": false,
    "default": null,
    "dateType":"datetime",
    "colsXS": 3,
    "colsSM": 3,
    "colsMD": 3,
    "colsLG": 3,
    "OffsetXS": 0,
    "OffsetSM": 0,
    "OffsetMD": 0,
    "OffsetLG": 0,
    "addClass": "",
    "name": "День час минута от",
    "fieldName": "dateFrom",
    "label": "День час минута от",
    "placeholder": null,
    "validationRule": null,
    "errName": null,
    "cyData": null,
    "enable": true,
    "readonly": false,
    "showTable": true,
    "disableInCreate": false,
    "relative": null,
    "SearchType": "Date",
    "subListId": 0,
    "isReadOnlyAdd": true,
    "isReadOnlyEdit": false,
    "watchAttr": null
  },
  {
    "type": "INPUT_DATE_TIME",
    "description": "Дата",
    "main": false,
    "default": null,
    "dateType":"datetime",
    "colsXS": 3,
    "colsSM": 3,
    "colsMD": 3,
    "colsLG": 3,
    "OffsetXS": 0,
    "OffsetSM": 0,
    "OffsetMD": 0,
    "OffsetLG": 0,
    "addClass": "",
    "name": "День час минута до",
    "fieldName": "dateTo",
    "label": "День час минута до",
    "placeholder": null,
    "validationRule": null,
    "errName": null,
    "cyData": null,
    "enable": true,
    "readonly": false,
    "showTable": true,
    "disableInCreate": false,
    "relative": null,
    "SearchType": "Date",
    "subListId": 0,
    "isReadOnlyAdd": true,
    "isReadOnlyEdit": false,
    "watchAttr": null
  },
  {
    "type": "INPUT",
    "description": "ИНН",
    "main": false,
    "default": null,
    "colsXS": 3,
    "colsSM": 3,
    "colsMD": 3,
    "colsLG": 3,
    "OffsetXS": 0,
    "OffsetSM": 0,
    "OffsetMD": 0,
    "OffsetLG": 0,
    "addClass": "",
    "name": "ИНН",
    "fieldName": "inn",
    "label": "ИНН",
    "placeholder": null,
    "validationRule": null,
    "errName": null,
    "cyData": null,
    "enable": true,
    "readonly": false,
    "showTable": true,
    "disableInCreate": false,
    "relative": null,
    "SearchType": "Text",
    "subListId": 0,
    "isReadOnlyAdd": true,
    "isReadOnlyEdit": false,
    "watchAttr": null
  },
  {
    "type": "INPUT",
    "description": "КПП",
    "main": false,
    "default": null,
    "colsXS": 3,
    "colsSM": 3,
    "colsMD": 3,
    "colsLG": 3,
    "OffsetXS": 0,
    "OffsetSM": 0,
    "OffsetMD": 0,
    "OffsetLG": 0,
    "addClass": "",
    "name": "КПП",
    "fieldName": "kpp",
    "label": "КПП",
    "placeholder": null,
    "validationRule": null,
    "errName": null,
    "cyData": null,
    "enable": true,
    "readonly": false,
    "showTable": true,
    "disableInCreate": false,
    "relative": null,
    "SearchType": "Text",
    "subListId": 0,
    "isReadOnlyAdd": true,
    "isReadOnlyEdit": false,
    "watchAttr": null
  },
  ]

export function mapReportToTableData(reportData) {
  const safe = (obj, defaults) => (obj && typeof obj === 'object' ? obj : defaults);
  const zero = { totalCount: 0, successCount: 0, failureCount: 0, avgLoadTimeMs: 0 };

  const personsToPMTFile = safe(reportData && reportData.personsToPMTFile, zero);
  const personsToPMTAPI = safe(reportData && reportData.personsToPMTAPI, zero);
  const personsFromPMTToEsb = safe(reportData && reportData.personsFromPMTToEsb, zero);
  const personsFromEsbToCorteos = safe(reportData && reportData.personsFromEsbToCorteos, zero);
  const personsFromCorteosToEsb = safe(reportData && reportData.personsFromCorteosToEsb, zero);

  const codeFromPMTToEsb = safe(reportData && reportData.codeFromPMTToEsb, zero);
  const codeFromEsbToCorteos = safe(reportData && reportData.codeFromEsbToCorteos, zero);
  const codeFromCorteosToEsb = safe(reportData && reportData.codeFromCorteosToEsb, zero);

  const companyLoadPersonsToCorteos = safe(reportData && reportData.companyLoadPersonsToCorteos, {});
  const companyLoadCodeToCorteos = safe(reportData && reportData.companyLoadCodeToCorteos, {});
  const personsLoaded = safe(reportData && reportData.personsLoaded, {});
  const personsFromEsbToCorteosGrouped = Array.isArray(reportData && reportData.personsFromEsbToCorteosGrouped) ? reportData.personsFromEsbToCorteosGrouped : [];

  return {
    tableData: [
      { "": "Загруженные персоны в PMT файлом", "Всего": personsToPMTFile.totalCount, "Успешные": personsToPMTFile.successCount, "Ошибки": personsToPMTFile.failureCount },
      { "": "Загруженные персоны в PMT Через API", "Всего": personsToPMTAPI.totalCount, "Успешные": personsToPMTAPI.successCount, "Ошибки": personsToPMTAPI.failureCount },
      { "": "Переданные персоны из PMT в шину", "Всего": personsFromPMTToEsb.totalCount, "Успешные": personsFromPMTToEsb.successCount, "Ошибки": personsFromPMTToEsb.failureCount },
      { "": "Переданные  персоны из шины в Corteos", "Всего": personsFromEsbToCorteos.totalCount, "Успешные": personsFromEsbToCorteos.successCount, "Ошибки": personsFromEsbToCorteos.failureCount },
      { "": "Переданные  персоны из Corteos в шину", "Всего": personsFromCorteosToEsb.totalCount, "Успешные": personsFromCorteosToEsb.successCount, "Ошибки": personsFromCorteosToEsb.failureCount }
    ],
    tableDataCodes: [
      { "": "Переданные коды из PMT в шину", "Всего": codeFromPMTToEsb.totalCount, "Успешные": codeFromPMTToEsb.successCount, "Ошибки": codeFromPMTToEsb.failureCount },
      { "": "Переданные  коды из Corteos в шину", "Всего": codeFromCorteosToEsb.totalCount, "Успешные": codeFromCorteosToEsb.successCount, "Ошибки": codeFromCorteosToEsb.failureCount }
    ],
    tableDataCompanyPerson: Object.entries(companyLoadPersonsToCorteos).map(([company, stats]) => ({
      "Компания (ИНН | КПП)": `${company}`,
      "Всего": (stats && stats.totalCount) || 0,
      "Успешные": (stats && stats.successCount) || 0,
      "Ошибки": (stats && stats.failureCount) || 0
    })),
    tableDataCompanyCodes: Object.entries(companyLoadCodeToCorteos).map(([company, stats]) => ({
      "Компания (ИНН | КПП)": `${company}`,
      "Всего": (stats && stats.totalCount) || 0,
      "Успешные": (stats && stats.successCount) || 0,
      "Ошибки": (stats && stats.failureCount) || 0
    })),
    tableDataTime: Object.entries(personsLoaded).map(([time, stats]) => ({
      "": time,
      "Всего": (stats && stats.totalCount) || 0,
      "Успешные": (stats && stats.successCount) || 0,
      "Ошибки": (stats && stats.failureCount) || 0
    })),
    tableDataGroupedEsbToCorteos: personsFromEsbToCorteosGrouped.map((item) => ({
      "Группа ошибки": item && (item.errorGroup || item.group || item.name || ''),
      "Всего": (item && item.totalCount) || 0,
      "Успешные": (item && item.successCount) || 0,
      "Ошибки": (item && item.failureCount) || 0
    })),
    tableDataAvgTime: [
      { "": "Загрузка персоны в PMT файлом", "миллисекунд": personsToPMTFile.avgLoadTimeMs ?? 0 },
      { "": "Загрузка персоны в PMT Через API", "миллисекунд": personsToPMTAPI.avgLoadTimeMs ?? 0 },
      { "": "Передача персоны из PMT в шину", "миллисекунд": personsFromPMTToEsb.avgLoadTimeMs ?? 0 },
      { "": "Передача персоны из шины в Corteos", "миллисекунд": personsFromEsbToCorteos.avgLoadTimeMs ?? 0 },
      { "": "Передача персоны из Corteos в шину", "миллисекунд": personsFromCorteosToEsb.avgLoadTimeMs ?? 0 }
    ]
  };
}


export function mapAvgTimeToStackedSeries(tableDataAvgTime) {
  const block = Array.isArray(tableDataAvgTime) ? tableDataAvgTime[0] : null;
  const rows = block && Array.isArray(block.data) ? block.data : [];
  const result = [];
  const stateGroups = ["Всего", "Ошибки", "Успешные"];
  rows.forEach(r => {
    const timeLabel = r[""] || '';
    const hasGroups = stateGroups.some(k => r[k] !== undefined && r[k] !== null);
    if (hasGroups) {
      stateGroups.forEach(groupName => {
        const val = Number(r[groupName] || 0);
        result.push({ state: timeLabel, stateGroup: groupName, avgTime: isNaN(val) ? 0 : val });
      });
      return;
    }
    if (r["миллисекунд"] !== undefined) {
      const val = Number(r["миллисекунд"] || 0);
      result.push({ state: timeLabel, stateGroup: "Всего", avgTime: isNaN(val) ? 0 : val });
    }
  });
  return result;
}

